module.exports = __webpack_public_path__ + "assets/images/animal_y.c9aaadb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/animal_y.png
// module id = 677
// module chunks = 1